import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../ExecutionContext.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpMethod_Get_instance;
var HttpMethod_Post_instance;
var HttpMethod_entriesInitialized;
function HttpMethod_initEntries() {
  if (HttpMethod_entriesInitialized)
    return Unit_instance;
  HttpMethod_entriesInitialized = true;
  HttpMethod_Get_instance = new (HttpMethod())('Get', 0);
  HttpMethod_Post_instance = new (HttpMethod())('Post', 1);
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var HttpHeaderClass;
function HttpHeader() {
  if (HttpHeaderClass === VOID) {
    class $ {
      constructor(name, value) {
        this.i49_1 = name;
        this.j49_1 = value;
      }
      toString() {
        return 'HttpHeader(name=' + this.i49_1 + ', value=' + this.j49_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.i49_1);
        result = imul(result, 31) + getStringHashCode(this.j49_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpHeader()))
          return false;
        if (!(this.i49_1 === other.i49_1))
          return false;
        if (!(this.j49_1 === other.j49_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpHeader');
    HttpHeaderClass = $;
  }
  return HttpHeaderClass;
}
function _get_hasBody__xziwnf($this) {
  return !($this.l49_1 == null) || !($this.m49_1 == null);
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(statusCode) {
        this.k49_1 = statusCode;
        this.l49_1 = null;
        this.m49_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.n49_1 = ArrayList().p2();
      }
      o49(bodySource) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!!_get_hasBody__xziwnf(this)) {
          var message = 'body() can only be called once';
          throw IllegalStateException().o(toString(message));
        }
        this.l49_1 = bodySource;
        return this;
      }
      y48(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.n49_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.i2(element);
        return this;
      }
      a49(headers) {
        // Inline function 'kotlin.apply' call
        this.n49_1.u2(headers);
        return this;
      }
      p37() {
        return new (HttpResponse())(this.k49_1, this.n49_1, this.l49_1, this.m49_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      constructor(statusCode, headers, bodySource, bodyString) {
        this.p49_1 = statusCode;
        this.q49_1 = headers;
        this.r49_1 = bodySource;
        this.s49_1 = bodyString;
      }
      t49() {
        var tmp0_elvis_lhs = this.r49_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.s49_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = (new (Buffer())()).b3z(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(method, url) {
        this.t48_1 = method;
        this.u48_1 = url;
        this.v48_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.w48_1 = ArrayList().p2();
        this.x48_1 = Companion_getInstance().u42_1;
      }
      z48(body) {
        // Inline function 'kotlin.apply' call
        this.v48_1 = body;
        return this;
      }
      y48(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.w48_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.i2(element);
        return this;
      }
      a49(headers) {
        // Inline function 'kotlin.apply' call
        this.w48_1.u2(headers);
        return this;
      }
      h44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.x48_1 = this.x48_1.i44(executionContext);
        return this;
      }
      p37() {
        return new (HttpRequest())(this.t48_1, this.u48_1, this.w48_1, this.v48_1, this.x48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {
      constructor(method, url, headers, body, executionContext) {
        this.u49_1 = method;
        this.v49_1 = url;
        this.w49_1 = headers;
        this.x49_1 = body;
        this.y49_1 = executionContext;
      }
      z49(method, url) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Builder_0())(method, url);
        if (!(this.x49_1 == null)) {
          this_0.z48(this.x49_1);
        }
        this_0.a49(this.w49_1);
        this_0.h44(this.y49_1);
        return this_0;
      }
      a4a(method, url, $super) {
        method = method === VOID ? this.u49_1 : method;
        url = url === VOID ? this.v49_1 : url;
        return $super === VOID ? this.z49(method, url) : $super.z49.call(this, method, url);
      }
    }
    initMetadataForClass($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
function HttpMethod_Get_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Get_instance;
}
function HttpMethod_Post_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Post_instance;
}
//region block: exports
export {
  HttpHeader as HttpHeader1d7ldebjomr00,
  Builder_0 as Builder2ocxamygt14i4,
  Builder as Builder1mo34du82b3c6,
  HttpMethod_Get_getInstance as HttpMethod_Get_getInstance139ackgavp29i,
  HttpMethod_Post_getInstance as HttpMethod_Post_getInstance1acsve6b42vet,
};
//endregion

//# sourceMappingURL=Http.mjs.map
